export enum ReportDataType {
  PRODUCTS = "returned_products",
  ORDERS = "returns",
  WARRANTY_CUSTOMERS = "warranty_customers",
  PURCHASED_EXTENDED_WARRANTY = "purchased_extended_warranty",
}
